const hasFailureResponse = (response: { failure: boolean }): boolean => {
  return response.failure;
};

export default hasFailureResponse;
